/**
 * Line chart – weight (kg) over time. Uses Recharts.
 */
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import styles from './WeightChart.module.css';

export function WeightChart({ data }) {
  if (!data || data.length === 0) {
    return <p className={styles.empty}>No data for this exercise yet.</p>;
  }

  const formatDate = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' });
  };

  const chartData = data.map(({ date, weight }) => ({
    date: formatDate(date),
    fullDate: date,
    weight: Number(weight),
  }));

  return (
    <div className={styles.wrap}>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border-hairline)" />
          <XAxis
            dataKey="date"
            tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
            stroke="var(--border-hairline)"
          />
          <YAxis
            tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
            stroke="var(--border-hairline)"
            unit=" kg"
            domain={['auto', 'auto']}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--bg-surface)',
              border: '1px solid var(--border-hairline)',
              borderRadius: 'var(--radius-sm)',
            }}
            labelStyle={{ color: 'var(--text-primary)' }}
            formatter={(value) => [`${value} kg`, 'Weight']}
            labelFormatter={(label) => label}
          />
          <Line
            type="monotone"
            dataKey="weight"
            stroke="var(--gold)"
            strokeWidth={2}
            dot={{ fill: 'var(--gold)', r: 4 }}
            activeDot={{ r: 6, fill: 'rgba(200, 162, 75, 0.8)' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
